/* globals jQuery */
/*
 * Deprecating this functionality and no new functionality should be added to this file.
 * TODO: Put these functionalities with their related files if needed, else delete them.
 */

const legacy = {
  handlers() {
    // SK Signup - show/hide description fields on focus
    // eslint-disable-next-line func-names
    jQuery('.sk-signup-form .ginput_container input').focus(function() {
      jQuery('.gfield_description').css('display', 'none');
      jQuery(this)
        .parents('.gfield')
        .find('.gfield_description')
        .fadeIn(500);
    });
    jQuery('.sk-signup-form .ginput_container input').focusout(() => {
      jQuery('.gfield_description').css('display', 'none');
    });
  }
};

export default legacy;
